import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: (body) => ({
                url: `admin/login`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        // get: builder.query({
        //     query: () => ({
        //         url: ''
        //     }),
        // }),
    })
})

export const { useLoginMutation } = Api
